
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor","stroke":"currentColor","stroke-width":".2"}},[_c('path',{attrs:{"d":"M14.129 6.436h-2.2V6.09a1.1 1.1 0 00-1.094-1.094H8.672A1.1 1.1 0 007.578 6.09v.346h-2.2a.374.374 0 000 .748h.735v7.652a1.1 1.1 0 001.09 1h5.1a1.1 1.1 0 001.09-1.007V7.191h.735a.374.374 0 100-.748zM8.323 6.09a.347.347 0 01.347-.347h2.161a.347.347 0 01.347.347v.346H8.324zm3.978 8.991h-5.1a.349.349 0 01-.345-.315V7.187h5.785v7.578a.348.348 0 01-.34.32z"}}),_c('path',{attrs:{"d":"M8.806 9.014a.377.377 0 00-.376.377v3.272a.376.376 0 10.752 0V9.391a.377.377 0 00-.376-.377zM10.697 9.014a.377.377 0 00-.376.377v3.272a.376.376 0 10.752 0V9.391a.377.377 0 00-.376-.377z"}})])])
          )
        }
      }
    